import { HttpBackend, HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../environments/environment";
import { BrandWebConfiguration } from "../models/brand-web-configuration.model";

@Injectable({ providedIn: "root" })
export class BrandsService {
    private readonly httpClient = new HttpClient(inject(HttpBackend));

    public webConfiguration: BrandWebConfiguration | undefined;

    public async getWebConfiguration(): Promise<BrandWebConfiguration> {
        return (this.webConfiguration ??= await firstValueFrom(
            this.httpClient.get<BrandWebConfiguration>(`${environment.baseUrl}/api/brands/webconfiguration`, {
                params: { appUrl: environment.webAppUrl }
            })
        ));
    }
}
